import {getValidToken} from '../utils/tokenUtils';

// Fetches the list of all available service contract names from the backend
export const fetchContracts = async () => {
    const token = await getValidToken();
    if (!token) {
        throw new Error('Din session har gått ut. Logga in igen.');
    }
    const res = await fetch('/test-runner/get-service-contracts-names', {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    if (!res.ok) {
        throw new Error('Kunde inte nå tjänsten. Försök igen.');
    }
    return res.json();
};

// Fetches the test suites and test cases for a given service contract
export const fetchSuitesAndCases = async (contract) => {
    const token = await getValidToken();
    if (!token) {
        throw new Error('Din session har gått ut. Logga in igen.');
    }
    const res = await fetch(`/test-runner/get-testsuites-and-testcases-names?serviceContractName=${contract}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    if (!res.ok) {
        throw new Error('Kunde inte nå tjänsten. Försök igen.');
    }
    return res.json();
};

// Fetches the documentation for a specific service contract (usually returns text/HTML content)
/* export const fetchContractDoc = async (contract) => {
  const res = await fetch(`/test-runner/service-contract-doc?serviceContractName=${contract}`, {
    headers: {
        Authorization: `Bearer ${token}`,
    },
  });
  return res.text();
}; */

// Sends a list of selected test cases to the backend to be executed.
// When sandbox=true the run is isolated and never counted as an official report.
export const runSelectedTestCases = async (payload, activeOrgId, sandbox = false) => {
    const token = await getValidToken();
    if (!token) {
        throw new Error('Din session har gått ut. Logga in igen.');
    }
    const params = new URLSearchParams({ organisationId: activeOrgId });
    if (sandbox) params.append('sandbox', 'true');

    const res = await fetch(`/test-runner/selected-test-cases?${params.toString()}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(payload)
    });
    
    // Check if the response is successful
    if (!res.ok) {
        // Handle timeout errors (504 Gateway Timeout)
        if (res.status === 504) {
            throw new Error('Testkörningen tog för lång tid. Testerna kan fortfarande köras på servern. Försök uppdatera resultaten om en stund.');
        }
        // Surface the backend's message when available (e.g. missing test data configuration)
        const errorData = await res.json().catch(() => null);
        throw new Error(errorData?.message || 'Serverfel. Försök igen eller kontakta support.');
    }

    // Check if response is JSON
    const contentType = res.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
        const text = await res.text();
        throw new Error('Oväntat svar från servern. Kontakta support om problemet kvarstår.');
    }
    
    return res.json(); // Return parsed JSON response with test results
};

// Submits manually entered test results (scenario 3: tests run locally).
// payload: { contractId, executionId?, testResults: [{ testSuiteName, testCaseName, status, justification }] }
export const submitManualResults = async (payload, activeOrgId) => {
    const token = await getValidToken();
    if (!token) throw new Error('Din session har gått ut. Logga in igen.');

    const res = await fetch(
        `/test-runner/manual-results?organisationId=${encodeURIComponent(activeOrgId)}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
        }
    );

    if (!res.ok) throw new Error('Serverfel. Försök igen eller kontakta support.');
    return res.json();
};
